// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3F3N_","detailsBorder":"styles_detailsBorder__1Drhk"};